import { render, staticRenderFns } from "./EditSeriesGeneralPanel.vue?vue&type=template&id=41cab375&scoped=true"
import script from "./EditSeriesGeneralPanel.vue?vue&type=script&lang=js"
export * from "./EditSeriesGeneralPanel.vue?vue&type=script&lang=js"
import style0 from "./EditSeriesGeneralPanel.vue?vue&type=style&index=0&id=41cab375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cab375",
  null
  
)

export default component.exports